export default {
  productNotAvailable: {
    id: 'product_no_available',
    defaultMessage: 'Oh fiddlesticks! This product is not available',
  },
}
